import { useTranslation } from 'react-i18next';

import { Container } from '@/components';
import { useBreadcrumbs } from '@/features/header';
import { AdvisorsHeader, ServicesContent } from '@/features/services';

export function Services() {
  const { t } = useTranslation(['services']);
  useBreadcrumbs(() => [{ title: t(`Advisors`) }]);

  return (
    <Container size="xl">
      <div className="mx-auto flex flex-col space-y-3 py-6">
        <AdvisorsHeader />
        <ServicesContent />
      </div>
    </Container>
  );
}
